// extracted by mini-css-extract-plugin
export default {"container":"jtrN2L","title":"KI4KmL","textButton":"wvxMlI"};